import React from "react";

const BASE_WIDTH = 14;
const BASE_HEIGHT = 15;

export default function ComplianceSuccess(props: {
  height?: number;
  width?: number;
}) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7.5" r="6.25" stroke="#38CC3F" strokeWidth="1.5" />
      <path
        d="M10.25 5.5L5.61897 10.5L3.25 7.88662"
        stroke="#38CC3F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
